export default "__VITE_ASSET__735109ba__"